
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phone/mypage/invitation",
      function () {
        return require("private-next-pages/phone/mypage/invitation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/phone/mypage/invitation"])
      });
    }
  